// src/components/CheckoutModal.js
import React, { useEffect, useRef } from 'react';
import styles from './CheckoutModal.module.css';

const priceLabels = {
  en: { subtotal: 'Subtotal',       tax: 'Tax',       total: 'Total' },
  es: { subtotal: 'Subtotal',       tax: 'Impuestos', total: 'Total' },
  de: { subtotal: 'Zwischensumme',  tax: 'MwSt',      total: 'Gesamt' },
  fr: { subtotal: 'Sous-total',     tax: 'TVA',       total: 'Total'  },
  it: { subtotal: 'Subtotale',      tax: 'IVA',       total: 'Totale' },
  pt: { subtotal: 'Subtotal',       tax: 'Imposto',   total: 'Total'  },
  uk: { subtotal: 'Підсумок',       tax: 'ПДВ',       total: 'Усього' },
  ru: { subtotal: 'Итого',          tax: 'Налог',     total: 'Всего'  },
};

export default function CheckoutModal({ transactionId, priceBreakdown, onClose, onComplete }) {
  const containerClass = useRef(`checkout-container-${Date.now()}`);
  const modalBodyRef   = useRef(null);
  const locale   = navigator.language || 'en-US';
  const langCode = locale.split('-')[0];
  const t        = priceLabels[langCode] || priceLabels.en;

  useEffect(() => {
    const body          = modalBodyRef.current;
    const initialHeight = body
      ? `${body.clientHeight}px`
      : `${window.innerHeight}px`;

    window.Paddle.Checkout.open({
      transactionId,
      settings: {
        displayMode: 'inline',
        frameTarget: containerClass.current,
        frameInitialHeight: initialHeight,
        frameStyle:
          'width:100%;background-color:transparent;border:none;',
      },
    });

    const handleCompleted = e => onComplete?.(e.detail);
    const handleClosed    = e => onClose?.(e.detail);

    window.addEventListener('PaddleCheckoutCompleted', handleCompleted, {
      once: true,
    });
    window.addEventListener('PaddleCheckoutClosed', handleClosed, {
      once: true,
    });

    return () => {
      window.Paddle.Checkout.close();
      window.removeEventListener('PaddleCheckoutCompleted', handleCompleted);
      window.removeEventListener('PaddleCheckoutClosed', handleClosed);
    };
  }, [transactionId, onClose, onComplete]);

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <button
            className={styles.closeBtn}
            onClick={() => {
              window.Paddle.Checkout.close();
              onClose();
            }}
          >
            ✕
          </button>
        </div>

        <div className={styles.modalBody} ref={modalBodyRef}>
          <div className={containerClass.current} />
        </div>

        {priceBreakdown && (
          <div className={styles.breakdownBar}>
	   <div className={styles.marquee}>
             {`${t.subtotal}: ${priceBreakdown.currency_code}${priceBreakdown.subtotal}   •   `}
             {`${t.tax}: ${priceBreakdown.currency_code}${priceBreakdown.tax}   •   `}
             {`${t.total}: ${priceBreakdown.currency_code}${priceBreakdown.total}`}
           </div>
          </div>
        )}

        <div className={styles.modalFooter}>
          <small>© Quality Performance Core / © Paddle Payment</small>
        </div>
      </div>
    </div>
  );
}

